import { createAction } from '@reduxjs/toolkit';
import * as types from './type';

const AllowCookiesStatus = createAction(types.ALLOW_COOKIES_STATUS);

export default AllowCookiesStatus;
